import {Color} from '@benchling/nucleus-ui';
import React from 'react';
import ReactFlow, {Background, MarkerType} from 'reactflow';

import {useEntityMapActorRef, useEntityMapSelector} from './EntityMapMachineProvider';
import EntityNode from './EntityNode';

const ENTITY_MAP_NODE_TYPES = {
  entity: EntityNode,
};

/**
 * Renders a view of the entity map for a given entityId
 */
export default function EntityMapView(): JSX.Element {
  const graphNodesById = useEntityMapSelector((s) => s.context.graphNodesById);
  const graphEdgesById = useEntityMapSelector((s) => s.context.graphEdgesById);
  const actorRef = useEntityMapActorRef();

  const graphNodes = Array.from(graphNodesById.values());
  const graphEdges = Array.from(graphEdgesById.values());

  return (
    <ReactFlow
      defaultEdgeOptions={{
        style: {
          color: Color.GRAY_400,
        },
        // TODO(BNCH-127286): Verify that it is correct to assume we can always set a end marker
        markerEnd: {
          type: MarkerType.Arrow,
          width: 20,
          height: 20,
          color: Color.GRAY_400,
        },
        labelStyle: {
          color: Color.GRAY_800,
        },
      }}
      nodes={graphNodes}
      edges={graphEdges}
      nodeTypes={ENTITY_MAP_NODE_TYPES}
      fitView={true}
      onNodesChange={(changes) => {
        actorRef.send({type: 'onNodesChange', changes});
      }}
      onEdgesChange={(changes) => {
        actorRef.send({type: 'onEdgesChange', changes});
      }}
    >
      <Background />
    </ReactFlow>
  );
}
